import { Component, OnInit, signal } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { JwtService } from 'src/auth/services/jwt.service';

@Component({
  selector: 'cert-role-info',
  templateUrl: './role-info.component.html',
  styles: ``,
  standalone: false,
})
export class RoleInfoComponent implements OnInit {
  currentEdOrgName?: string;
  currentRoles: string[];
  currentAllowedPortals = signal<string[]>([]);
  userEmail!: string | undefined;
  userName!: string | undefined;

  constructor(
    private readonly jwtService: JwtService,
    private readonly activeModal: NgbActiveModal,
  ) {
    this.currentEdOrgName = jwtService.currentEdOrgName;
    this.currentRoles = jwtService.roles;
    this.userEmail = jwtService.getUserEmail();
    this.userName = jwtService.getUserName();
  }

  ngOnInit() {
    this.jwtService.allowedPortals$.subscribe((x) => this.currentAllowedPortals.set(x));
  }
  close() {
    this.activeModal.dismiss();
  }
}
